export default __webpack_public_path__ + "static/emergent_logo-light-2-eb5f1caca426b2330ba42c05de07e80a.webp";